"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useIdleListener = exports.useIsIdle = exports.IdleStateProvider = exports.createIdleListener = void 0;
var react_1 = __importDefault(require("react"));
var react_native_1 = require("./react-native");
var web_1 = require("./web");
function createIdleListener() {
    try {
        return new react_native_1.IdleStateListenerReactNative();
    }
    catch (e) {
        return new web_1.IdleStateListenerWeb();
    }
}
exports.createIdleListener = createIdleListener;
var IdleContext = react_1["default"].createContext(null);
var IdleListenerContext = react_1["default"].createContext(null);
exports.IdleStateProvider = react_1["default"].memo(function IdleStateProvider(_a) {
    var children = _a.children, active = _a.active;
    var idleListener = react_1["default"].useMemo(function () { return createIdleListener(); }, []);
    var isActive = idleListener.useIsActive();
    return (react_1["default"].createElement(IdleContext.Provider, { value: !(isActive && active !== false) },
        react_1["default"].createElement(IdleListenerContext.Provider, { value: idleListener }, children)));
});
function useIsIdle() {
    var value = react_1["default"].useContext(IdleContext);
    if (value === null) {
        throw new Error('useIsIdle must be used within an IdleStateProvider');
    }
    return value;
}
exports.useIsIdle = useIsIdle;
function useIdleListener() {
    var value = react_1["default"].useContext(IdleListenerContext);
    if (value == null) {
        throw new Error('useIdleListener must be used within an IdleStateProvider');
    }
    return value;
}
exports.useIdleListener = useIdleListener;
